import {
  CoreBreadcrumbItem,
  CoreBreadcrumbProps,
} from '../shared/types/breadcrumb.types';

import styles from './breadcrumb.module.scss';

function CoreBreadcrumb(props: CoreBreadcrumbProps) {
  const { items } = props;

  return (
    <nav
      id={props.id}
      aria-label="Breadcrumb"
      className={styles['core-breadcrumbs']}
    >
      <ol className={styles['core-breadcrumbs-list']}>
        {items.map((breadcrumb: CoreBreadcrumbItem) => {
          return breadcrumb.current ? (
            <li
              className={styles['core-breadcrumb']}
              key={breadcrumb.id}
              aria-current="page"
            >
              {breadcrumb.title}
            </li>
          ) : (
            <li className={styles['core-breadcrumb']} key={breadcrumb.id}>
              <a
                onClick={(event) => breadcrumb.onClick?.(event, breadcrumb)}
                href={breadcrumb.link.url}
                className={styles['core-breadcrumb-link']}
              >
                {breadcrumb.title}
              </a>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default CoreBreadcrumb;
